import styled from '@emotion/styled';

export const PanelTitle = styled('div')`
  margin-left: 0px;
  margin-right: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: bold;
  overflow: hidden;
`;

export const QueryError = styled('div')`
  color: red;
  font-weight: 600;
  padding: 1rem;
`;

export const ErrorMessage = styled.span`
  color: red;
  font-weight: 600;
`;

export const QueryLoading = styled('div')`
  color: gray;
  font-weight: 600;
  padding: 1rem;
`;

export const QueryWarning = styled('div')`
  padding: 1rem;
  color: gray;
  font-weight: 600;
  font-size: 1.2rem;
  font-style: italic;
`;

export interface ILabelProps {
  bold?: boolean;
  center?: boolean;
  size?: 'small' | 'normal' | 'large';
  visibilityHidden?: boolean;
  color?: string;
  isLink?: boolean;
  uppercase?: boolean;
  marginBottom?: boolean;
}

export const Header = styled(PanelTitle)`
  font-size: 18px;
  font-weight: bold;
`;

export const Label = styled(PanelTitle) <ILabelProps>`
  ${(props) => (props.marginBottom ? `margin-bottom: 1rem;` : '')};
  font-size: ${(props) => (props.size === 'small' ? `0.8rem` : props.size === 'large' ? `1.4rem` : `1.2rem`)};
  font-weight: ${(props) => (props.bold ? `bold` : `normal`)};
  font-weight: ${(props: ILabelProps) => (props.bold ? `bold` : `normal`)};
  padding-bottom: 0.4rem;
  white-space: initial;
  color: ${(props: ILabelProps) => (props.color || `#4a4a4a`)};
  visibility: ${(props: ILabelProps) =>
    props.visibilityHidden ? `hidden` : `visible`};
  ${({ isLink, color }) => {
    return isLink ? `border-bottom: 1px solid ${color || '#4a4a4a'};` : ``;
  }}
  ${({ isLink }) => {
    return isLink ? `font-style: italic;` : ``;
  }}
  ${(props) => props.uppercase ? `text-transform: uppercase` : ``};
  ${(props) => props.center ? `text-align: center` : ``};

`;

export const StrongLabel = styled('span')`
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 0.1rem;
`;

export const FormInputLabel = styled(StrongLabel) <ILabelProps>`
  ${(props) => (props.marginBottom ? `margin-bottom: 1rem;` : '')};
  font-size: ${(props) => (props.size === 'small' ? `0.8rem` : props.size === 'large' ? `1.4rem` : `1.2rem`)};
  font-weight: ${(props) => (props.bold ? `bold` : `normal`)};
  text-align: ${(props) => (props.center ? `center` : `left`)};
  white-space: initial;
  line-height: 9px;
  letter-spacing: 1px;
`;

export const CustomerInfoHeading = styled(Label) <ILabelProps>`
  margin-top: 0.4px;
  margin-bottom: 0.4px;
  font-size: 1.1rem;
  line-height: normal;
  font-weight: ${(props) => (props.bold ? `bold` : `normal`)};
  text-align: ${(props) => (props.center ? `center` : `left`)};
  white-space: initial;
  letter-spacing: 1px;
  color:inherit;
`;

export const StreetName = styled('span') <ILabelProps>`
  font-weight: ${(props) => (props.bold ? `bold` : `normal`)};
`;
